module.exports = __webpack_public_path__ + "static/media/hub.48cb4565.jpeg";